// extracted by mini-css-extract-plugin
export var formContainer = "_ln-0";
export var message = "_ln-1";